var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.779,
    height: 23.998,
    viewBox: "0 0 12.779 23.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-chess-3392452",
    transform: "translate(-300.621 -37.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247987",
    "data-name": "Path 247987",
    d: "M436.591,559.734H429.33c.208-.227,1.8-2.173,2.06-8.674h3.251a42.349,42.349,0,0,0,1.951,8.674Z",
    transform: "translate(-125.962 -502.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247988",
    "data-name": "Path 247988",
    d: "M343.949,971.72l-11.348.007c-.042-.6.033-1.309,1.035-1.473a.991.991,0,0,0,.928-1.018h7.409c.217,1,.725,1,.725,1,1.72.116,1.25,1.483,1.25,1.483Z",
    transform: "translate(-31.289 -911.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247989",
    "data-name": "Path 247989",
    d: "M313.389,1100.508l.011-.9a.835.835,0,0,0-.629-.432c-.425-.031-11.606.032-11.606.032a1.145,1.145,0,0,0-.544.536l.011.768Z",
    transform: "translate(0 -1038.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247990",
    "data-name": "Path 247990",
    d: "M484.649,498.338a.419.419,0,0,1-.448.38h-4.249a.385.385,0,1,1,0-.76H484.2a.419.419,0,0,1,.448.38Z",
    transform: "translate(-175.066 -450.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247991",
    "data-name": "Path 247991",
    d: "M570.758,38.433a.652.652,0,1,1-.652-.652.652.652,0,0,1,.652.652",
    transform: "translate(-263.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247992",
    "data-name": "Path 247992",
    d: "M514.39,436.55h3.656v1.06H514.39Z",
    transform: "translate(-209.207 -390.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247993",
    "data-name": "Path 247993",
    d: "M469.769,205.934s-.457-.612-.977-.5-1.124.53-1.426.567-.31.3-.174.594a13.607,13.607,0,0,1,.932,3.51l3.609.028a12.99,12.99,0,0,1,.905-3.436s.439-.64-.228-.731a1.749,1.749,0,0,1-1.042-.466.724.724,0,0,0-.877.165c-.23.338-.367.32-.724.274Z",
    transform: "translate(-162.934 -164.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247994",
    "data-name": "Path 247994",
    d: "M488.08,113.575s.414-2.194,2.3-2.255a2.49,2.49,0,0,1,2.475,2.242.654.654,0,0,1-.377-.082c-.211-.11-.832-.621-1.3-.338s-.6.594-.814.421a1.638,1.638,0,0,0-1.325-.421c-.521.156.393-.85.74-1.069a.149.149,0,0,0-.237-.1,2.489,2.489,0,0,0-1.025,1.48.691.691,0,0,1-.442.122Z",
    transform: "translate(-183.458 -71.969)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueen);
export default __webpack_public_path__ + "static/media/queen.8c392de78bf95bfd81967ff28698c21a.svg";
export { ForwardRef as ReactComponent };